import { Box, Fade, SxProps, Theme, useScrollTrigger } from "@mui/material";
import { FC, PropsWithChildren } from "react";

const Show: FC<PropsWithChildren<{ show?: boolean; }>> = ({
    children,
    show
}) => {
    if (!show) {
        return null;
    }

    return (
        <Fade in={true}>
            <div>
                {children}
            </div>
        </Fade>
    );
}

export default Show;
